import { StyleSheet } from 'react-native';
import { normalize } from 'Theme';

export const defaultStyles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center'
    },
    backgroundImage: {
        flex: 1,
        width: '100%'
    },
    buttonContinue: {
        width: 358,
        height: 56,
        textAlign: 'center',
        alignSelf: 'auto',
        justifyContent: 'center',
        position: 'absolute',
        bottom: 7
    },
    textContinue: {
        fontSize: 25
    }
});

export const landscapeStyles = StyleSheet.create({
    buttonContinue: {
        width: '17.5%',
        height: '8%',
        textAlign: 'center',
        alignSelf: 'auto',
        justifyContent: 'center',
        position: 'absolute',
        bottom: '7%'
    },
    textContinue: {
        fontSize: normalize(9)
    }
});
